import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  IFeotClockRequest,
  IFeotClockResponse,
  IFeotClockSnapshot,
} from '../qa-tools-service/feot-clock.interface';
import { environment } from '../../../environments/environment';

/** Talks to api_platform directly; RequestInterceptor adds the access-token header. */
@Injectable({
  providedIn: 'root',
})
export class FeotClockService {
  private readonly _apiUrl = environment.pureSpectrum.url;

  constructor(private _http: HttpClient) {}

  getFeotClock(surveyId: number) {
    return this._http.get<IFeotClockSnapshot>(
      `${this._apiUrl}/internal/surveys/${surveyId}/feot-clock`
    );
  }

  patchFeotClock(surveyId: number, input: IFeotClockRequest) {
    return this._http.patch<IFeotClockResponse>(
      `${this._apiUrl}/internal/surveys/${surveyId}/feot-clock`,
      input
    );
  }
}
